import {
  FETCH_ACTIVITY_LOGS_REQUEST,
  FETCH_ACTIVITY_LOGS_SUCCESS,
  FETCH_ACTIVITY_LOGS_FAILURE,
} from '../../types/activityLog/activityLogTypes';
import { getActivityLogs as fetchLogsApi } from '../../../api/activityLogApi';

export const fetchActivityLogs = (filters = {}) => async (dispatch) => {
  dispatch({ type: FETCH_ACTIVITY_LOGS_REQUEST });
  try {
    const logs = await fetchLogsApi(filters);
    dispatch({ type: FETCH_ACTIVITY_LOGS_SUCCESS, payload: logs });
  } catch (error) {
    dispatch({ type: FETCH_ACTIVITY_LOGS_FAILURE, payload: error.message || 'Failed to fetch activity logs' });
  }
}; 